export default {
  data () {
    return {
      messageTypes: [
        { 
          type: 'orderConfirmation',
          title: 'Order confirmation',
          description: ['This message is sent via email to the customer after they have placed their order.', 'However, if a Payment confirmation can be sent immediately after the order has been placed, for example with online payments, this message will NOT be sent.'],
          editor: 'textEditor'
        },
        { 
          type: 'openOrderConfirmation',
          title: 'Open order confirmation',
          description: 'This message is sent via email to the customer after they have placed an open order.',
          editor: 'textEditor'
        },
        { 
          type: 'paymentConfirmation',
          title: 'Payment confirmation',
          description: 'This message is sent via email to the customer after the order has been marked as paid.',
          editor: 'textEditor'
        },
        { 
          type: 'billingConfirmation',
          title: 'Billing confirmation',
          description: 'This message is sent via email to the customer after an order has been approved for billing in the administration interface.',
          editor: 'textEditor'
        },
        { 
          type: 'processConfirmation',
          title: 'Process confirmation',
          description: 'This message is optionally sent via email to the customer after the order has been marked as processed.',
          editor: 'textEditor'
        },
        { 
          type: 'orderCancellation',
          title: 'Order cancellation',
          description: 'This message is sent via email to the customer if the order has been cancelled.',
          editor: 'textEditor'
        },
        {
          type: 'orderRequestReceived',
          title: 'Order request received',
          description: 'This message is sent to the customer when they submit a cancellation or move request.',
          editor: 'textEditor'
        },
        {
          type: 'orderRequestNotification',
          title: 'Order request notification',
          description: 'This message is sent to the shop when a customer submits a cancellation or move request.',
          editor: 'textEditor'
        },
        { 
          type: 'afterSales',
          title: 'After-sales letter',
          description: 'This message is optionally sent to the customer a specified time after the reservation has ended.',
          editor: 'textEditor'
        },
        { 
          type: 'paymentLink',
          title: 'Payment link',
          description: 'This message is optionally sent to the customer along with payment links.',
          editor: 'textEditor'
        },
        { 
          type: 'confirmationlink',
          title: 'Confirmation link',  
          description: 'This message is optionally sent to the customer along with confirmation links.',
          editor: 'textEditor'
        },
        {
          type: 'finalPayment',
          title: 'Final payment notification',
          description: 'This message is sent to the customer when the final payment of a payment plan is due.',
          editor: 'textEditor'
        },
        {
          type: 'finalPaymentLate',
          title: 'Final payment late notification',
          description: 'This message is sent to the customer when the final payment of a payment plan is late.',
          editor: 'textEditor'
        },
        {
          type: 'subscriptionStart',
          title: 'Subscription started',
          description: 'This message is sent to the customer when a recurring subscription starts.',
          editor: 'textEditor'
        },
        {
          type: 'subscriptionCancel',
          title: 'Subscription cancelled',
          description: 'This message is sent to the customer when a recurring subscription is cancelled.',
          editor: 'textEditor'
        },
        {
          type: 'subscriptionEnd',
          title: 'Subscription ended',
          description: 'This message is sent to the customer when a recurring subscription ends.',
          editor: 'textEditor'
        },
        {
          type: 'subscriptionPaymentFailed',
          title: 'Subscription payment overdue',
          description: 'This message is sent to the customer when a recurring subscription is suspended because a payment is overdue.',
          editor: 'textEditor'
        },
        {
          type: 'subscriptionRenewal',
          title: 'Subscription renewal payment',
          description: 'This message is sent to the customer with the payment link when the next period of a recurring subscription is billed.',
          editor: 'textEditor'
        },
        {
          type: 'subscriptionChargeFailed',
          title: 'Subscription automatic payment failed',
          description: 'This message is sent to the customer with a payment link when the automatic payment of a recurring subscription fails.',
          editor: 'textEditor'
        }
      ],
      additionalMessageTypes: [
        {
          type: 'deliveryTerms',
          title: 'Order and cancellation terms',
          description: ['This page should contain your shop\'s delivery terms and shipping information.', 'It is automatically linked to in the storefront and the order process.'],
          editor: 'richEditor'
        },
        {
          type: 'privacyPolicy',
          title: 'Privacy policy',
          description: ['This page should contain your shop\'s privacy policy.', 'It is automatically linked to in the storefront and the order process.'],
          editor: 'richEditor'
        },
        {
          type: 'accessibilityStatement',
          title: 'Accessibility statement',
          description: ['This page should contain your shop\'s accessibility statement.', 'It is displayed in the footer of the storefront.'],
          editor: 'richEditor'
        },
        {
          type: 'orderCompletion',
          title: 'Order completion page',
          description: 'This message is shown to the customer after they have placed their order.',
          editor: 'richEditor'
        },
        {
          type: 'checkinPage',
          title: 'Check in page',
          description: 'This page should contain any message you wish to show people who are checking in or out of reservations.',
          editor: 'richEditor'
        },
        {
          type: 'moreDescription',
          title: 'Additional info description',
          description: 'Add an additional description to the \'Additional Info\' field at the end of the order process.',
          editor: 'textEditor'
        },
        {
          type: 'termsDescription',
          title: 'Terms description',
          description: 'Add an additional description to the Terms and Conditions part at the end of the order process.',
          editor: 'textEditor'
        },
        {
          type: 'marketingDescription',
          title: 'Marketing Consent description',
          description: 'Add an additional description to the Marketing Consent part at the end of the order process.',
          editor: 'textEditor'
        }
      ],
    }
  },
  methods: {
    getMessageData(type) {
      let msg
      if (msg = this.messageTypes.find(m => m.type === type)) {
        return msg
      }
      if (msg = this.additionalMessageTypes.find(m => m.type === type)) {
        return msg
      }
      return null
    },
    getMessageTitle(type) {
      const message = this.getMessageData(type)
      if (message && message.title) {
        return message.title
      }
      return type
    },
    getMessageDescription(type) {
      const message = this.getMessageData(type)
      if (message && message.description) {
        return message.description
      }
      return ''
    },
    getMessageEditor(type) {
      const message = this.getMessageData(type)
      if (message && message.editor) {
        return message.editor
      }
      return 'textEditor'
    }
  }
}
